/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SocialLinkDto } from '../models/SocialLinkDto';
import type { UpdateSocialLinkRequest } from '../models/UpdateSocialLinkRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SocialLinkControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns SocialLinkDto OK
     * @throws ApiError
     */
    public updateJson({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: UpdateSocialLinkRequest,
    }): CancelablePromise<SocialLinkDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/social-links/update/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns SocialLinkDto OK
     * @throws ApiError
     */
    public updateMultipart({
        id,
        formData,
    }: {
        id: string,
        formData?: {
            lineUrl?: string;
            instagramUrl?: string;
            contentTitle1?: string;
            contentTitle2?: string;
            contentDetail1?: string;
            contentDetail2?: string;
            isEnabled?: boolean;
            bannerFile?: Blob;
            videoFile?: Blob;
            carouselList?: Array<Blob>;
            carouselCaptions?: Array<string>;
            carouselLinks?: Array<string>;
            carouselOrders?: Array<number>;
        },
    }): CancelablePromise<SocialLinkDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/social-links/update-multipart/{id}',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns SocialLinkDto OK
     * @throws ApiError
     */
    public generateSocialLink({
        formData,
    }: {
        formData?: {
            shopId: string;
            contentTitle1: string;
            contentTitle2?: string;
            contentDetail1?: string;
            contentDetail2?: string;
            lineUrl?: string;
            videoFile?: Blob;
            bannerFile?: Blob;
            carouselList?: Array<Blob>;
            carouselCaptions?: Array<string>;
            carouselLinks?: Array<string>;
            carouselOrders?: Array<number>;
        },
    }): CancelablePromise<SocialLinkDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/social-links/generate',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns SocialLinkDto OK
     * @throws ApiError
     */
    public getById({
        id,
    }: {
        id: string,
    }): CancelablePromise<SocialLinkDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/social-links/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns SocialLinkDto OK
     * @throws ApiError
     */
    public getAllByShopId({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<Array<SocialLinkDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/social-links/shop/{shopId}/all',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns SocialLinkDto OK
     * @throws ApiError
     */
    public getAll1(): CancelablePromise<Array<SocialLinkDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/social-links/all',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
